module.exports = __webpack_public_path__ + "static/img/logoimg.e6c9131d.png";